/**
 * Casse et accents écartés : « thouare » trouve « Thouaré ». Le pliage seul — chaque comparaison
 * y ajoute le sien (espaces, ponctuation, ligatures).
 */
export function foldForSearch(value) {
    return value
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
}
//# sourceMappingURL=fold-for-search.js.map